import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { virusScanStatus } from '../Services/Api';

interface VirusScanPayload {
  status: string;
}

export default ({ blobKey, name = 'attachments', onSuccess, setDisabledForm }: any) => {
  const [stop, setStop] = useState(false);

  const { isLoading, data } = useQuery(
    ['virusScanStatus', name, blobKey],
    () => virusScanStatus(blobKey),
    {
      onSuccess: ({ data: payload }: { data: VirusScanPayload }) => {
        if (payload.status !== 'no_scan') {
          setStop(true);
          onSuccess(payload.status);
          setDisabledForm(false);
        } else {
          setDisabledForm(true);
        }
      },
      onError: () => {
        setStop(true);
      },
      enabled: !!blobKey,
      refetchInterval: stop ? false : 2000,
      refetchIntervalInBackground: true,
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    if (isLoading) {
      setDisabledForm(true);
    }
  }, [isLoading]);

  return { status: data?.data?.status, isLoading, scanned: stop };
};
